// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"Empty_emptyWrapper__3NsPh","emptyImage":"Empty_emptyImage__2wUJ-","emptyTitle":"Empty_emptyTitle__2DIuR","emptyDescription":"Empty_emptyDescription__Pdku8"};